/** After login, ProductViewer reads this and calls star API once for this product id. */
export const PENDING_PRODUCT_STAR_STORAGE_KEY = 'robotop_pending_product_star';
